<template>
    <header class="position-fixed w-100 h-100">
        <!-- Desktop -->
        <div class="main-header d-none d-md-flex flex-column justify-content-between">
            <nav class="main-header__navbar d-flex justify-content-between">
                <div class="pt-1 pl-2">
                    <div class="main-header__logo">
                        <a href="#home">
                            rschumachr
                        </a>
                    </div>
                    <Menu />
                </div>
                <div class="main-header__social pt-1 pr-2">
                    <Social />
                </div>
            </nav>
            <div class="main-header__scroll mx-auto mb-1 text-center">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="mouse-alt" class="svg-inline--fa fa-mouse-alt fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 0h-64A160 160 0 0 0 0 160v192a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V160A160 160 0 0 0 224 0zm112 352a112.12 112.12 0 0 1-112 112h-64A112.12 112.12 0 0 1 48 352V160A112.12 112.12 0 0 1 160 48h64a112.12 112.12 0 0 1 112 112zM192 96a32 32 0 0 0-32 32v32a32 32 0 0 0 64 0v-32a32 32 0 0 0-32-32z"></path></svg>
                <div class="text">SCROLL</div>
            </div>
        </div>

        <!-- Mobile -->
        <div class="mobile-header d-md-none">
            <div class="mobile-header__logo text-center pt-1 d-none">
                <a href="#home">
                    rschumachr
                </a>
            </div>
            <div class="mobile-header__hamburger d-flex align-items-center" @click="toggleMobileNav()">
                <div class="hamburger" :class="{ 'hamburger--active' : isMobileNavOpen}">
                </div>
            </div>
            <transition name="mobile-nav">
                <nav v-if="isMobileNavOpen" class="mobile-header__nav d-flex justify-content-between">
                    <div class="container pt-1 text-center d-flex flex-column justify-content-around">
                        <div class="mobile-header__logo pt-1">
                            <a href="#home" @click="toggleMobileNav()">
                                rschumachr
                            </a>
                        </div>
                        <Menu :onclick.sync="isMobileNavOpen" />
                        <div class="mobile-header__social mx-auto">
                            <Social />
                        </div>
                    </div>
                </nav>
            </transition>
        </div>
    </header>
</template>

<script>
import Axios from 'axios'
import Menu from './Menu'
import Social from './Social'

export default {
    name: 'Header',

    components: {
        Menu,
        Social
    },

    data() {
        return {
            pages: [],
            isMobileNavOpen: false
        }
    },

    created() {
        Axios.get(`${this.$VUE_APP_API_URL}/pages?visible=true`).then(res =>{
            this.pages = res.data.sort((a, b) => {
                return a.order - b.order
            })
        })
    },

    methods: {
        toggleMobileNav() {
            this.isMobileNavOpen = !this.isMobileNavOpen
        }
    }
}
</script>